import React from "react";
import {Redirect, useLocation} from "react-router-dom";
import {URL_TEMPLATES as URL} from "src/urlTemplates";
import PropTypes from "prop-types";

const TokenGuard = ({children}) => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);
    const token = urlSearchParams.get("token");

    if (!token) {
        return <Redirect to={URL.LOGIN}/>;
    }

    return <>{children}</>;
};

TokenGuard.propTypes = {
    children: PropTypes.node
};

export default TokenGuard;
